import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
    static targets = ["menu"]

    toggle() {
        this.menuTarget.classList.toggle("hidden")
    }

    hide(event) {
        //メニュー外のクリックで閉じる
        if (!this.element.contains(event.target)) {
            this.menuTarget.classList.add("hidden")
        }
    }
}
